<template>
  <div
    class="user-button"
    :class="{ active: showUserMenu }"
  >
    <div
      v-if="userName"
      v-on-clickaway="closeMenu"
      class="user-info"
      @click="toggleMenu"
    >
      <div class="user">
        {{ userName }}
      </div>
      <div class="organization">
        <LoadingSkeleton
          height="16px"
          :amount="1"
          :is-loaded="!!organizerName"
        >
          {{ organizerName }}
        </LoadingSkeleton>
      </div>

      <div class="avatar">
        <RoundImage
          v-if="base64Avatar"
          :src="base64Avatar"
        />
        <LoadingSkeletonBase
          v-else
          :speed="1"
          :height="20"
          :width="20"
          :svg-style="{ height: '50px', width: '50px' }"
        >
          <circle
            cx="10"
            cy="10"
            r="10"
          />
        </LoadingSkeletonBase>
      </div>
    </div>
    <div v-else>
      <UserButtonLoader />
    </div>

    <HeaderMenuContent class="menu-container">
      <RouterLink
        :to="{ name: mySettingsModule.name }"
        @click.native="showUserMenu = false"
      >
        <div class="link">
          <div class="text">
            Min profil
          </div>
        </div>
      </RouterLink>
      <a
        href=""
        @click.prevent.stop="showUserMenu = false"
      >
        <div
          class="link"
          @click="logout"
        >
          <div class="text">Logga ut</div>
        </div>
      </a>
    </HeaderMenuContent>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway2';

import GetterTypes from '@/store/constants/getters';
import LoadingSkeleton from '@/components/common/misc/loading-skeleton/LoadingSkeleton.vue';
import settingsModules from '@/modules/definitions/settingsModules';

import MutationTypes from '@/store/constants/mutations';
import UserButtonLoader from '@/components/layout/header/loader/UserButtonLoader.vue';
import LoadingSkeletonBase from '@/components/common/misc/loading-skeleton/base/LoadingSkeletonBase.vue';
import RoundImage from '@/components/common/multimedia/round-image/RoundImage.vue';
import HeaderMenuContent from './views/HeaderMenuContent.vue';

export default {
  name: 'UserButton',
  components: {
    LoadingSkeleton,
    HeaderMenuContent,
    RoundImage,
    LoadingSkeletonBase,
    UserButtonLoader,
  },
  mixins: [clickaway],
  data() {
    return {
      mySettingsModule: settingsModules.MySettings,
      showUserMenu: false,
    };
  },
  computed: {
    ...mapGetters([
      GetterTypes.USER_NAME,
      GetterTypes.ORGANIZER_NAME,
      GetterTypes.BASE64_AVATAR,
    ]),
  },
  methods: {
    toggleMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    closeMenu() {
      this.showUserMenu = false;
    },
    logout() {
      this.$store.commit(MutationTypes.SIGN_OUT);
      this.$router.push('/login');
      delete this.$axios.defaults.headers.common.Authorization;
    },
  },
};
</script>

<style lang="scss" scoped>
  .user-button {
    height: calc(100% - 1px);
    position: relative;
    display: grid;
    align-items: center;
    border-bottom: 1px solid var(--primary-divider-hex);

    &:not(.active) {
      .menu-container {
        opacity: 0;
        height: 0;
        padding: 0;
        overflow: hidden;
      }
    }

    &:hover {
      .menu-container {
        height: auto;
        overflow: visible;
        padding: 10px;
        opacity: 1;
      }
    }

    .user-info {
      cursor: pointer;
      padding: 0 0;
      display: grid;
      grid-template-areas: "user avatar" "organization avatar";
      grid-template-columns: 1fr 60px;

      @media (max-width: $smallBreakpoint) {
        grid-template-areas: "avatar";
        grid-template-columns: 1fr;
        justify-items: center;
        padding: 0;
      }

      .user {
        @media (max-width: $smallBreakpoint) {
          display: none;
        }

        overflow: hidden;
        text-overflow: clip;
        white-space: nowrap;
        text-align: right;
        font-size: 13px;
        grid-area: user;
        align-self: flex-end;
        color: var(--accent-text-alt-color-hex);
      }

      .organization {
        @media (max-width: $smallBreakpoint) {
          display: none;
        }

        max-width: 190px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        font-weight: 400;
        grid-area: organization;
        text-align: right;
        align-self: flex-start;
        line-height: 1.5;
        color: rgba(var(--accent-text-discrete-rgb), 0.8);
      }

      .avatar {
        grid-area: avatar;
        text-align: center;
        justify-self: end;
        align-self: center;
      }
    }
  }
</style>
